import React from 'react';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp } from '@fortawesome/pro-light-svg-icons/faArrowUp';
import { faArrowDown } from '@fortawesome/pro-light-svg-icons/faArrowDown';
import { TypedMemo } from '../../../common/types';
import styles from './DeltaPill.module.scss';

export interface DeltaPillProps {
  /** Drives sign/colour. */
  value: number;
  /** Appended after the number, e.g. "%". */
  suffix?: string;
  /** Show a leading "+" on positive values (default true). */
  showPlus?: boolean;
  /** Override the rendered label entirely (sign/colour still come from `value`). */
  label?: React.ReactNode;
  className?: string;
}

const DeltaPillComponent: React.FC<DeltaPillProps> = ({ value, suffix = '', showPlus = true, label, className }) => {
  const tone = value > 0 ? styles.pos : value < 0 ? styles.neg : styles.flat;
  const icon = value > 0 ? faArrowUp : value < 0 ? faArrowDown : null;

  const text =
    label ?? (value === 0 ? '' : `${value > 0 && showPlus ? '+' : ''}${Math.abs(value).toLocaleString()}${suffix}`);

  return (
    <span className={clsx(styles.delta, tone, 'fig', className)}>
      {icon !== null ? <FontAwesomeIcon icon={icon} /> : <span className={styles.flatMark}>—</span>}
      {value === 0 && label === undefined ? '' : text}
    </span>
  );
};

export const DeltaPill = TypedMemo(DeltaPillComponent);
